import React from "react";

function fmtDate(ts) {
  if (!ts) return "—";
  const d = ts.toDate ? ts.toDate() : new Date(ts);
  return (
    d.toLocaleDateString("en-GB", { day: "2-digit", month: "short" }) +
    ", " +
    d.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit", hour12: false })
  );
}

const STATUS_VARIANT = {
  OPEN: "bad",
  CLOSED: "ok",
  "UNDER REVIEW": "warn",
  "PENDING CLOSURE": "neutral",
};

const SOURCE_VARIANT = {
  public: "ok",
  customerSupport: "info",
  independentEngineer: "neutral",
};

const SOURCE_LABEL = {
  public: "Public",
  customerSupport: "CS",
  independentEngineer: "IE",
};

// One row in a complaint list. `showLocation` prefixes the timestamp with the
// complaint's PCT number — used on the home (multi-location) list, omitted on
// the single-location list where it's redundant.
function ComplaintRow({ c, showLocation, onComplaintClick }) {
  const status = c.status?.currentStatus || "OPEN";
  const source = c.issuedBy?.type;
  return (
    <div key={c.documentId} className="lrow" onClick={() => onComplaintClick && onComplaintClick(c)}>
      <div className="li">
        <div className="ln">{c.category || "Complaint"}</div>
        <div className="ls" style={{ fontFamily: "var(--font-mono)", letterSpacing: ".02em" }}>{c.documentId}</div>
        <div className="ls">
          {showLocation && c.location?.PCTNo ? `${c.location.PCTNo} · ` : ""}{fmtDate(c.createdAt)}
        </div>
      </div>
      <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", gap: "4px", flexShrink: 0 }}>
        <span className={`snap-pill ${STATUS_VARIANT[status] || "neutral"}`}>{status}</span>
        {source && (
          <span className={`snap-pill ${SOURCE_VARIANT[source] || "neutral"}`}>
            {SOURCE_LABEL[source] || source}
          </span>
        )}
      </div>
    </div>
  );
}

export default ComplaintRow;
